import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AppContext } from '../Context/AppContextProvide';

function AdminAuthRoute({ component: Component, render: renderProp, authed, ...rest }) {
  const { user, isLoggedOut, loading, authInitialized } = useContext(AppContext);

  const isAuthenticated = user?.user_id && new Date().getTime() < user.will_expire_at;
  const isAdmin = user?.access_type_cd === 'a';

  if (isLoggedOut && !isAuthenticated) {
    return <Redirect to={{ pathname: '/signin' }} />;
  }

  if (loading && !authInitialized) {
    return <div>Loading...</div>;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated && isAdmin) {
          return renderProp ? renderProp(props) : <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{ pathname: '/notfound', state: { from: props.location } }}
            />
          );
        }
      }}
    />
  );
}

export default AdminAuthRoute;
